module.exports = __webpack_public_path__ + "static/media/JCB.d02084ca.svg";